import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { VenueModel } from '../../models/venues/venue.model';
import { TranslateService } from "@ngx-translate/core";
import { VenueService } from '../../services/venues/venue.service';
import { Subject, takeUntil } from 'rxjs';
import {
  ListEditCapacityTemplatesComponent
} from "./list-edit-capacity-templates/list-edit-capacity-templates.component";

@Component({
  selector: 'app-venues',
  templateUrl: './venues.component.html',
  styleUrls: ['./venues.component.scss']
})
export class VenuesComponent implements OnInit {

  //#region Fields
  public listAllVenues: Array<VenueModel> = new Array<VenueModel>();
  public unsubscribe: Subject<void> = new Subject<void>();
  public imagePath: string = './assets/images/logo/venuelogo.png'
  public items: { [name: string]: MenuItem[] } = {};
  public spinner: boolean;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public venueService: VenueService,
    private messageService: MessageService,
    public translate: TranslateService
  ) {
  }


  ngOnInit():void {
    this.getAllVenues();
  }
  //#endregion

  //#region Public Methods

  getAllVenues() {
    this.listAllVenues = new Array<VenueModel>();
    this.spinner = true;
    this.venueService.listvenues()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.listAllVenues = response;
        },
        error: errorResponse => {
          this.spinner= false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  };

  openEditCapacityForVenue(venueId: string) {
      const ref = this.dialogService.open(ListEditCapacityTemplatesComponent, {
        data: {
          id: venueId,
        },
        header: this.translate.instant('VENUE.CREATE_CAPACITY'),
        width: '1000px'
      });
      ref.onClose.subscribe((item: any) => {
      });
  }
  //#endregion

  //#endregion
}
